import { z } from 'zod'

const AmountSchema = z.object({
  amount: z.number().optional(),
  currencyCode: z.string().optional(),
})
const AmountWithSurchargesSchema = AmountSchema.extend({
  amountWithSurcharges: z.number().optional(),
})

const AppliedModifierSchema = z.object({
  type: z.string().optional(),
  value: z.number().optional(),
})

const PromotionValiditySchema = z.object({
  code: z.string().optional(),
  description: z.string().optional(),
})

export const PromotionSchema = z.object({
  type: z.string(),
  code: z.string().optional(),
  promoCode: z.string().optional(),
  description: z.string().optional(),
  initialTotalAmount: AmountWithSurchargesSchema.optional(),
  initialLoyaltyAmount: AmountSchema.optional(),
  earnedPoints: AmountSchema.optional(),
  appliedModifier: AppliedModifierSchema.nullable().optional(),
  promotionValidity: PromotionValiditySchema.nullable().optional(),
})

export type Promotion = z.infer<typeof PromotionSchema>
